// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "styles" + "." + "14deb522e0eac0623909" + ".css";
};